import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const PageContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: ${theme.fonts.main};
  overflow: hidden;
`;

// 刷新按钮
export const RefreshButton = styled.button`
  background: ${theme.colors.primary};
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.4rem 0.8rem;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #e09d3e;  /* 深一点的主题色 */
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  @media (max-width: 768px) {
    padding: 0.3rem 0.6rem;
    font-size: 14px;
    margin-left: 5px;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem; /* 恢复顶部 padding */
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 0.8rem 1rem; /* 恢复顶部 padding */
  }
`;

export const Title = styled.h1`
  text-align: center;
  margin: 0 0 2rem 0;
  font-size: 2rem;
  color: #333;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin: 0 0 1rem 0;
  }
`;

export const TimetableDisplay = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-bottom: 4rem; /* 从 1rem 减少到 0.5rem */
`;

export const SliderContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  
  .slick-slider {
    flex: 1;
    display: flex !important;
    flex-direction: column;
  }
  
  .slick-list {
    flex: 1;
    padding: 0;
  }
  
  .slick-track {
    height: 100%;
    display: flex;
    align-items: flex-start;
  }
  
  .slick-slide {
    height: auto;
    
    > div {
      height: 100%;
    }
  }
  
  /* 简化的点指示器样式 */
  .custom-dots {
    position: relative;
    bottom: auto;
    margin-top: 0rem;
    display: flex !important;
    justify-content: center;
    gap: 0.5rem;
    list-style: none;
    padding: 0;
    
    li {
      margin: 0;
      
      .custom-dot {
        width: 12px;
        height: 12px;
        background: #e0e0e0;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background: #bbb;
          transform: scale(1.2);
        }
      }
      
      &.slick-active .custom-dot {
        background: ${theme.colors.primary};
        transform: scale(1.3);
      }
    }
    
    @media (max-width: 768px) {
      margin-top: 0.3rem;
      gap: 0.4rem;
      
      li .custom-dot {
        width: 10px;
        height: 10px;
      }
    }
  }
`;

/* 添加进度条样式的替代选项 */
export const ProgressIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem; /* 从 1rem 减少到 0.5rem */
  gap: 0.3rem;
  padding: 0.3rem; /* 从 0.5rem 减少到 0.3rem */
  
  @media (max-width: 768px) {
    margin-top: 0.3rem; /* 从 0.8rem 减少到 0.3rem */
    padding: 0.2rem; /* 从 0.3rem 减少到 0.2rem */
  }
`;

export const ProgressDot = styled.div`
  width: ${props => props.isActive ? '24px' : '8px'};
  height: 8px;
  border-radius: 4px;
  background: ${props => props.isActive ? theme.colors.primary : '#e0e0e0'};
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${props => props.isActive && `
    &::after {
      content: '${props.index + 1}';
      color: white;
      font-size: 10px;
      font-weight: 600;
    }
  `}
  
  &:hover {
    background: ${props => props.isActive ? theme.colors.primary : '#bbb'};
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    width: ${props => props.isActive ? '20px' : '6px'};
    height: 6px;
    
    ${props => props.isActive && `
      &::after {
        font-size: 8px;
      }
    `}
  }
`;

export const ProgressText = styled.div`
  margin-left: 1rem;
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
  
  @media (max-width: 768px) {
    margin-left: 0.8rem;
    font-size: 0.8rem;
  }
`;

export const NavArea = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100px; /* 增加悬停区域宽度 */
  ${props => props.direction === 'left' ? 'left: 0;' : 'right: 0;'}
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: ${props => props.direction === 'left' ? 'flex-start' : 'flex-end'};
  padding: ${props => props.direction === 'left' ? '0 0 0 20px' : '0 20px 0 0'};
  
  @media (max-width: 768px) {
    width: 60px; /* 移动端减小悬停区域 */
    padding: ${props => props.direction === 'left' ? '0 0 0 10px' : '0 10px 0 0'};
  }
`;

export const NavButton = styled.button`
  background: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
  transition: all 0.3s ease;
  opacity: ${props => props.isVisible ? 1 : 0};
  visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
  pointer-events: ${props => props.isVisible ? 'auto' : 'none'};

  &:hover {
    background: ${theme.colors.primaryDark || '#005b99'};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
`;

export const TimetableImage = styled.div`
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 0;
  height: calc(100vh - 56px - 70px - 70px); /* 减去顶部校区选择器的高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    margin: 0;
    height: calc(100vh - 56px - 60px - 60px); /* 移动端调整 */
  }
  
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
`;

export const ErrorPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 56px - 70px - 70px); /* 同样调整高度 */
  color: #999;
  font-size: 1.1rem;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 0;
  
  @media (max-width: 768px) {
    margin: 0;
    height: calc(100vh - 56px - 60px - 60px); /* 移动端调整 */
  }
`;


export const FixedCampusSelector = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid #eee;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  
  /* 移动端支持横向滚动 */
  @media (max-width: 768px) {
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0.8rem;
    gap: 0.8rem;
    
    /* 隐藏滚动条但保持功能 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
    
    &::-webkit-scrollbar {
      display: none; /* Chrome/Safari */
    }
    
    /* 添加渐变提示边缘可滚动 */
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 20px;
      pointer-events: none;
      z-index: 1;
    }
    
    &::before {
      left: 0;
      background: linear-gradient(to right, rgba(255, 255, 255, 0.95), transparent);
    }
    
    &::after {
      right: 0;
      background: linear-gradient(to left, rgba(255, 255, 255, 0.95), transparent);
    }
  }
`;
export const TopCampusSelector = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 0.5rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  
  /* 移动端支持横向滚动 */
  @media (max-width: 768px) {
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0.5rem 1rem;
    gap: 0.8rem;
    
    /* 隐藏滚动条但保持功能 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
    
    &::-webkit-scrollbar {
      display: none; /* Chrome/Safari */
    }
    
    /* 添加渐变提示边缘可滚动 */
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 20px;
      pointer-events: none;
      z-index: 1;
    }
    
    &::before {
      left: 0;
      background: linear-gradient(to right, rgba(255, 255, 255, 0.95), transparent);
    }
    
    &::after {
      right: 0;
      background: linear-gradient(to left, rgba(255, 255, 255, 0.95), transparent);
    }
  }
`;

export const LoadingPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: transparent;
  
  &::after {
    content: '';
    width: 40px;
    height: 40px;
    border: 4px solid #e0e0e0;
    border-top: 4px solid ${theme.colors.primary};
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @media (max-width: 768px) {
    &::after {
      width: 30px;
      height: 30px;
      border-width: 3px;
    }
  }
`;

export const CampusButton = styled.button`
  padding: 0.8rem 1.5rem;
  border: 2px solid ${props => props.isActive ? theme.colors.primary : '#ddd'};
  border-radius: 8px;
  background: ${props => props.isActive ? theme.colors.primary : '#fff'};
  color: ${props => props.isActive ? '#fff' : '#333'};
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 0.9rem;
  min-width: 120px;
  white-space: nowrap; /* 防止文字换行 */
  flex-shrink: 0; /* 防止按钮被压缩 */
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: ${theme.colors.primary};
    background: ${props => props.isActive ? theme.colors.primary : '#f8f9fa'};
  }
  
  @media (max-width: 768px) {
    padding: 0.7rem 1.2rem;
    font-size: 0.85rem;
    min-width: 100px;
    
    &:hover {
      transform: none; /* 移动端移除悬停动画 */
    }
    
    &:active {
      transform: scale(0.98);
    }
  }
`;

export const CurrentInfo = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.95);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  z-index: 5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  opacity: ${props => props.isVisible ? 1 : 0};
  visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
    top: 5px;
  }
`;

export const TimetableCount = styled.span`
  font-size: 0.8rem;
  font-weight: 400;
  margin-left: 0.3rem;
  opacity: 0.8;
`;

export const Content = styled.div`
  margin-top: 1rem;
`;

export const Future = styled.div`
  margin-top: 2rem;
`;

export const Section = styled.section`
  margin: 2.5rem 0;
  padding: 2rem 0;
`;

export const ImageGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
  margin: 2rem 0;
  img {
    max-width: 350px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    background: #fff;
  }
`;

export const ActivityGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
`;

export const ActivityCard = styled.div`
  width: 260px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 100%;
    height: 160px;
    object-fit: cover;
  }
  div {
    padding: 0.5rem 0.5rem 1rem 0.5rem;
  }
`;

export const HelpTip = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 500;
  z-index: 15;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  opacity: ${props => props.isVisible ? 1 : 0};
  visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  text-align: center;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.6rem 1.2rem;
    white-space: normal;
    max-width: 80vw;
  }
`;